<template>
  <div id="app">
    <!-- <nav class="navbar navbar-dark bg-dark"> -->
    <nav class="navbar navbar-dark" style="background-color: #707786;">
      <a class="navbar-brand" href="#"><i class="fas fa-rss-square"></i> Sensor Portal</a>
    </nav>

    <div class="row">
      <div class="col-9" id="mapContainer">
        <!-- <button type="button" id="addCommentButton" v-on:click="openAddNewComment()" class="btn btn-dark">Add Comment <i class="fa fa-comment-dots"></i></button> -->
        <Map/>
      </div>
      <div class="col-3 displayNone sideContainer border" id="flexContainer">
        <FlexContainer/>
      </div>
      <div class="col-3 border sideContainer">
        <SideMenu/>
      </div>
      <!-- <template v-if="!isAddNewComment">
        <div class="col-3 displayNone sideContainer border" id="flexContainer"> -->
          <!-- <FlexContainer/> -->
        <!-- </div>
      </template>
      <div class="col-3 border sideContainer">
        <template v-if="isAddNewComment"> -->
          <!-- <NewComment/> -->
        <!-- </template>
        <template v-else>
          <SideMenu/>
        </template>
      </div> -->
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Vuex from "vuex";

import Map from './components/Map.vue'
import SideMenu from './components/SideMenu.vue'
import FlexContainer from './components/FlexContainer.vue'

import mapStateModule from "./state/modules/mapStateModule.js"

const debug = process.env.NODE_ENV !== 'production'

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    mapModule: mapStateModule,
  },
  strict: debug
})

export default {
  name: 'App',
  data () {
    return {
      isAddNewComment: false
    }
  },
  components: {
    Map,
    SideMenu,
    FlexContainer
  },
  store:store
}
</script>

<style>
.sideContainer {
  /* border-style: ridge; */
  padding-left: 0!important;
  padding-right: 0!important;
}
.displayNone {
  display:none;
}
div#mapContainer {
  /* padding-left: 0!important; */
  padding-right: 0!important;
}

#app {
  overflow: hidden;
  /* font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px; */
}
</style>
